"use strict";

var __importDefault = function __importDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PlayPauseButton = void 0;

var react_1 = __importDefault(require("react"));

exports.PlayPauseButton = function (e) {
  var a = e.isPlaying,
      t = e.onClick,
      e = e.renderPlayPauseButton;
  return "function" == typeof e ? react_1.default.createElement("div", {
    className: "alice-carousel__play-btn",
    onClick: t
  }, e({
    isPlaying: a
  })) : react_1.default.createElement("div", {
    className: "alice-carousel__play-btn"
  }, react_1.default.createElement("div", {
    className: "alice-carousel__play-btn-wrapper"
  }, react_1.default.createElement("div", {
    onClick: t,
    className: "alice-carousel__play-btn-item" + (a ? " __pause" : "")
  })));
};